import { AbstractControl, Validators } from '@angular/forms';
import { QaroniBaseFormsDirective } from '@qaroni-core/directives/qaroni-base-forms/qaroni-base-forms.directive';

export class MonthDayDatepickerForm extends QaroniBaseFormsDirective {
  private skeleton = {
    date: [null, Validators.required],
  };

  public form = this.fb.group(this.skeleton);

  public get date(): AbstractControl {
    return this.form.get('date');
  }
}
